import { getCurrentApiUrl } from 'app/helpers';
import * as authActions from 'app/auth/store/actions';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import i18n from 'i18next';
import axios from 'axios';
import History from '@history';
import store from '../app/store';

const instance = axios.create({
  baseURL: getCurrentApiUrl(),
  headers: {
    // 'Authorization': `Bearer ${JwtService.getAccessToken()}`,
    'Content-Type': 'application/json'
  },
  responseType: 'json',
  timeout: 9999999999999999
});

instance.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  error => {
    if (!error.responses && error.response?.status !== 400) {
      return Promise.reject(error);
    }

    if (error.response.status === 400) {
      return Promise.reject(error);
    }

    const { status, data, config } = error.response;

    switch (status) {
      case 400: {
        if (data?.error === 'Login failed') {
          store.dispatch(
            MessageActions.showMessage({
              message: i18n.t('validation:login_failed')
            })
          );
        }
        break;
      }
      case 401: {
        store.dispatch(authActions.logoutUser());
        break;
      }
      case 403: {
        History.push('/error-403');
        break;
      }
      case 404: {
        History.push('/error-404');
        break;
      }
      case 500: {
        if (config.url !== '/feedbacks/dashboard') {
          History.push('/error-500');
        }
        break;
      }
      default:
        break;
    }

    return Promise.reject(error);
  }
);

export default instance;
